import React, { useEffect, useState } from 'react';
import { Paper, CssBaseline } from '@mui/material';

//gene20Themes import
import { withTheme } from './Assets/Gene20Themes';
import { makeStyles } from '@mui/styles';

import '@fontsource/roboto';

import Gene20DashBoard from './Examples/Gene20DashBBoard';
import Gene20Footer from './Examples/Gene20Footer';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Gene20Box from './Components/Gene20Box/Gene20Box';

import LandingPage from './pages/LandingPage';

const App = () => {
  const { pathname } = useLocation();
  const { dispatch } = useDispatch();
  // useEffect(() => {
  //   setLayout(dispatch, "page");
  // }, [pathname]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 10000);
  }, []);
  const [aunth, setAunth] = useState(false);
  const auntheticated = (e) => {
    setAunth(true);
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);
  const useStyles = makeStyles((theme) => ({
    root: {
      padding: '1vw',

      '&  a': {
        textDecoration: 'none',
      },
    },
  }));
  const classes = useStyles();
  const drawerWidth = 260;
  return (
    <React.Fragment>
      {!aunth ? (
        <Gene20Box display="flex" justifyContent="center" width="100%">
          <LandingPage auntheticated={auntheticated} />
        </Gene20Box>
      ) : (
        <Paper className={classes.root}>
          <CssBaseline />

          <>
            <Gene20DashBoard drawerWidth={drawerWidth} />
            <Gene20Footer drawerWidth={drawerWidth} />
          </>
        </Paper>
      )}
    </React.Fragment>
  );
};

export default withTheme(App);
